export const createLoadingOverlayStyles = (overlayOverrides = {}) => ({
  overlay: (base) => ({
    ...base,
    position: "fixed",
    ...overlayOverrides,
  }),
  content: (base) => ({
    ...base,
  }),
  spinner: (base) => ({
    ...base,
  }),
});

export const defaultLoadingOverlayStyles = createLoadingOverlayStyles();
